<template>

    <div
        class="separator separator-solid my-5"
        v-if="
            submission.author_credentials.editorial_consultant_used ||
            submission.author_credentials.writing_course_attended ||
            (submission.author_credentials.previous_published_books &&
                submission.author_credentials.previous_published_books
                    .length) ||
            (submission.author_credentials.prizes_and_grants &&
                submission.author_credentials.prizes_and_grants.length)
        "
    ></div>

    <div v-if="submission.author_credentials.editorial_consultant_used">
        <span class="d-flex align-items-center text-dark font-weight-bolder">{{ translate("Editorial Consultant") }}</span>

        <Consultant :presentation="submission" />
    </div>

    <div class="my-7"></div>

    <div v-if="submission.author_credentials.writing_course_attended">
        <span class="d-flex align-items-center text-dark font-weight-bolder">{{ translate("Writing Courses") }}</span>

        <WritingCourses :presentation="submission" />
    </div>

    <div class="my-7"></div>

    <div v-if="
        submission.author_credentials.previous_published_books &&
        submission.author_credentials.previous_published_books.length
    ">
        <span class="d-flex align-items-center text-dark font-weight-bolder">{{ translate("Previously Published Books") }}</span>

        <PublishedBooks :presentation="submission" />
    </div>

    <div v-if="
        submission.author_credentials.prizes_and_grants &&
        submission.author_credentials.prizes_and_grants.length
    ">
        <span class="d-flex align-items-center text-dark font-weight-bolder">{{ translate("Prizes and Grants") }}</span>

        <PrizesAndGrants :presentation="submission" />
    </div>
</template>

<script>
import Consultant from "@author/presentation-fields/view/Consultant.vue";
import WritingCourses from "@author/presentation-fields/view/WritingCourses.vue";
import PublishedBooks from "@author/presentation-fields/view/PublishedBooks.vue";
import PrizesAndGrants from "@author/presentation-fields/view/PrizesAndGrants.vue";

export default {
    props: ["submission"],

    components: {
        Consultant,
        WritingCourses,
        PublishedBooks,
        PrizesAndGrants,
    },
}
</script>
